<template lang="pug">
v-container.full-height.align-center.justify-center.d-flex
  v-card(outlined width="600px").pa-4
    h1.mb-4 Доступ запрещен
    p.mb-4 У вашего пользователя нет прав для просмотра страницы

    router-link(to="/")
      v-btn(color="primary") Перейти на главную

</template>

<script>
export default {
};
</script>
